import { atom, useRecoilState } from 'recoil'

import { IEventSsid } from './use-event-ssids'

const filtersState = atom<{ status: string }>({
  key: 'EventSsidsFilters',
  default: {
    status: 'current_or_future'
  }
})

const selection = atom<IEventSsid[]>({
  key: 'EventSsidsIdsSelected',
  default: []
})

const sortState = atom({
  key: 'EventSsidsSort',
  default: {
    by: 'start_tz',
    direction: 'asc'
  }
})

export const useSelection = () => {
  return useRecoilState(selection)
}

export const useSort = (): [{ direction: string; by: string }, (sort: string) => void] => {
  const [{ direction, by }, setSort] = useRecoilState<{ direction: string, by: string }>(sortState)
  return [
    { direction, by },
    sort => {
      if (by === sort) {
        const newDirection = direction === 'asc' ? 'desc' : 'asc'
        setSort({ by: sort, direction: newDirection })
      } else {
        setSort({ by: sort, direction: 'asc' })
      }
    }
  ]
}

export const useFilters = () => {
  return useRecoilState(filtersState)
}